// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-modal{position:fixed;top:0;left:0;width:100%;height:100%;z-index:20}.plv-iar-modal__main{position:absolute;background-size:100% 100%;background-repeat:no-repeat;box-sizing:border-box}.plv-iar-modal__main *{box-sizing:border-box}.plv-iar-modal{background-color:rgba(0,0,0,.6)}.plv-iar-modal__main--mobile{bottom:0;left:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
